import React, {useState, useRef, useEffect} from "react"
import { ImageList, ImageListItem, Box, FormControl, MenuItem, Select, InputLabel, IconButton, TextField, Typography } from "@mui/material";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { DataGrid } from '@mui/x-data-grid';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import {Statuses} from "../../data/RequestsData"

export function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function() {
      var reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }


const DisplayDevice = ({qr_dct}) => {
  const rows = qr_dct.valid
  const error = Array.isArray(qr_dct.error) ? qr_dct.error.join(', ') : ''

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'qr_string', headerName: 'Qr String', width: 90 },
    { field: 'author', headerName: 'Author', width: 90 },
    { field: 'device_type', headerName: 'Type', width: 90 },
    { field: 'status', headerName: 'Status', width: 90 }]


  return (
      <Box sx={{width: '100%', mb: 5}}>
        <DataGrid
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
        />
        <Typography  color="#F88379" fontSize={12}>
            Invalid: {error}
        </Typography>
      </Box>
    );
}


const SelectDestination = ({is_step_2, onInputchange}) => {
  const [status, setstatus] = useState('');

  const handleChange = (event) => {
    setstatus(event.target.value);
    onInputchange(event.target.value)
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      {is_step_2 ? (
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Destination Status</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={status} // Displaying only the last status
              onChange={handleChange}
            >
              <MenuItem value={Statuses[Statuses.length - 1].value}>{Statuses[Statuses.length - 1].title}</MenuItem>
            </Select>
        </FormControl>
      ) : (
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Destination Status</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={status}
            label="Destination Status"
            onChange={handleChange}
          >
            {Statuses.map((status, index) => (
              <MenuItem key={index} value={status.value}>
                {status.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
}


export const SetupDestination = ({is_stepper_2, onInputchange, qr_dct}) => {
  return (
    <Box>
      <DisplayDevice qr_dct={qr_dct}/>
      <SelectDestination is_step_2={is_stepper_2} onInputchange={onInputchange}/>
    </Box>
  )
}

export const AdvancedBox = ({handleimage, handlenote, setGrid}) =>  {
  return (
    <Box>
      <ImageUploader onInputchange={handleimage} setGrid={setGrid}/>
      <TextField
          label="Note"
          multiline
          maxRows={4}
          onChange={handlenote}
          sx = {{marginTop: '20px'}}
      />
  </Box>
  )
}

export const ImageUploader = ({onInputchange, setGrid}) => {
  const [images, setImages] = useState([]);
  const [rows, setrows] = useState({})
  const [base64, setbase64] = useState([])
  const fileInputRef = useRef()

  const handleImageChange = (event) => {
    const newImages = [...images];
   
    for (let i = 0; i < event.target.files.length; i++) {
      newImages.push(URL.createObjectURL(event.target.files[i]));
    }
    setImages(newImages);
  };

  const handleDeleteImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  useEffect(() => {
    const fetchBase64Images = async () => {
      let base64Images = [];
      if (images.length > 0) {
        for (let i = 0; i < images.length; i++) {
          await new Promise((resolve) => {
            toDataURL(images[i], function(dataUrl) {
              base64Images = [...base64Images, dataUrl.split('base64,')[1]];
              resolve();
            });
          });
        }
        onInputchange(base64Images);
        setbase64(base64Images)
      } else {
        onInputchange([])
        setbase64([])
      }
    };
  
    fetchBase64Images();
  }, [images]);
  
  return (
    <div>
        <div >
            {images.length > 0 && <ImageList sx={{ width: 'inherit', height: 200 }} cols={5} rowHeight={164}>
                    {images.map((image, index) => (
                    <ImageListItem key={index} sx={{ width: '100px', position: "relative" }}>
                        <img src={image} alt={`Preview ${index}`} style={{ width: '100px', height: '100px', marginRight: '10px' }} />
                        <RemoveCircleOutlineIcon onClick={() => handleDeleteImage(index)} sx = {{color: "red", position: "absolute", right: "1px"}}/>
                    </ImageListItem>
                    ))}
                </ImageList>}
        </div>
        <Box sx = {{display: "flex", justifyContent: 'center', alignItems: "center", width: "200px", border: 1, borderColor: "lightgray", my: 2}}>
            <div>
              <label htmlFor="file-upload" style = {{textAlign: "center"}} >
                  <AddPhotoAlternateIcon color="primary"/> <br></br>
                  Upload Images
              </label>
              <input
                  id="file-upload"
                  type="file"
                  multiple
                  onChange={(e) => handleImageChange(e)}
                  ref={fileInputRef} // Assigning ref to access the file input
                  style={{ display: 'none' }} // Hide the input element
              />
            </div>
            <div>
              {images.length > 0 && <IconButton sx = {{alignContent: "center"}} onClick={() => {setGrid(true)}}>
                    <KeyboardDoubleArrowRightIcon color="primary" sx = {{ml: 5}}/>
                </IconButton>}
            </div>
        </Box>
    </div>
  );
};

